import React from "react";
import { NavbarCMS, TablePublications } from "../../components";
import { useSelector } from "react-redux";

const PublicationCMS = () => {
    const setting = useSelector((state) => state?.combineReducer?.settings);
    return (
        <div className="h-full w-full">
            <NavbarCMS module={setting?.publication_document_list?.navbar} />
            <TablePublications />
        </div>
    )
}

export default PublicationCMS;